export default __webpack_public_path__ + "static/media/apollo-market-logo.5490c2d4.png";